var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-sheet",
        {
          staticClass: "pa-1 sticky-sheet",
          style: {
            "background-color": _vm.$vuetify.theme.dark ? "#1e1e1e" : "#fff",
          },
        },
        [
          _c(
            "h2",
            { staticStyle: { "margin-top": "0.5em", "margin-bottom": "1em" } },
            [
              _c("div", {
                staticStyle: { display: "inline-block", width: "24px" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Best Hit")]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt-3",
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "padding-bottom": "32px",
          },
        },
        [
          _vm.bestHit && _vm.bestHit.topHit
            ? _c("TopHitEntries", {
                ref: "bestHit",
                attrs: {
                  entry: _vm.bestHit,
                  mode: _vm.mode,
                  columnName: _vm.columnName,
                  thumbnailUrl: _vm.thumbnailUrl,
                  isActive: _vm.isActive,
                  isSpinning: _vm.isActive && _vm.viewerSpinning,
                  searchType: _vm.searchType,
                },
                on: {
                  activate: _vm.handleCardActivate,
                  resetView: _vm.handleToolbarResetView,
                  toggleSpin: _vm.handleToolbarToggleSpin,
                  jump: function ($event) {
                    return _vm.$emit("jumpTo", _vm.bestHitIndex)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.thumbnailItem
        ? _c("StructureViewerThumbnail", {
            ref: "thumbnailViewer",
            attrs: {
              thumbnailItem: _vm.thumbnailItem,
              hits: _vm.hits,
              mode: _vm.mode,
              searchType: _vm.searchType,
              queryPdb: _vm.queryPdb,
            },
            on: {
              "thumbnail-ready": _vm.setThumbnail,
              "viewer-ready": _vm.handleViewerReady,
              "spin-change": function ($event) {
                _vm.viewerSpinning = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }